import DateType from "consts/TimeViewDateType";
import ValueType from "consts/TimeViewValueType";

const TimeViewDateFilter = {
  PercentDaily: `${ValueType.Percent}-${DateType.Daily}`,
  PercentWeekly: `${ValueType.Percent}-${DateType.Weekly}`,
  PercentMonthly: `${ValueType.Percent}-${DateType.Monthly}`,
  PercentQuarterly: `${ValueType.Percent}-${DateType.Quarterly}`,
  PercentYearly: `${ValueType.Percent}-${DateType.Yearly}`,
  CountDaily: `${ValueType.Count}-${DateType.Daily}`,
  CountWeekly: `${ValueType.Count}-${DateType.Weekly}`,
  CountMonthly: `${ValueType.Count}-${DateType.Monthly}`,
  CountQuarterly: `${ValueType.Count}-${DateType.Quarterly}`,
  CountYearly: `${ValueType.Count}-${DateType.Yearly}`,
};

export default TimeViewDateFilter;
